import React from 'react'
import { scrollToId } from '../Helpers/scrollToId'

export function AnchorScrollTo({
	className,
	pointerId,
	children,
	moreClickActions,
}) {
	return (
		<a
			className={`link ${className !== undefined && className}`}
			rel="noreferrer"
			href={`#${pointerId}`}
			onClick={(event) => {
				event.preventDefault()
				scrollToId(pointerId)

				if (moreClickActions) {
					moreClickActions()
				}
			}}
		>
			{children}
		</a>
	)
}
